import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from '../components/ui/Toast.tsx';
import { ApiError } from './api.ts';

/**
 * 뮤테이션 meta 로 토스트 문구를 정한다 (CR-027).
 *   useMutation({ …, meta: { success: '저장했습니다' } })   성공 문구 지정
 *   useMutation({ …, meta: { success: false } })            성공 토스트 생략 (화면 이동·자체 안내가 있는 경우)
 *   useMutation({ …, meta: { error: false } })              실패 토스트 생략 (폼 안 ErrorText 로만 보일 때)
 */
declare module '@tanstack/react-query' {
  interface Register { mutationMeta: { success?: string | false; error?: false }; queryMeta: { error?: false } }
}
const msg = (e: unknown) => (e instanceof Error ? e.message : String(e));

/** 앱 전체(주 화면·분할 화면)가 공유하는 쿼리 캐시 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
  mutationCache: new MutationCache({
    onSuccess: (_data, _vars, _ctx, m) => { if (m.meta?.success !== false) toast.success(m.meta?.success ?? '처리되었습니다'); },
    onError: (e, _vars, _ctx, m) => { if (m.meta?.error !== false) toast.error(msg(e)); },
  }),
  queryCache: new QueryCache({
    // 조회 실패: 로그인 만료(401)는 인증 흐름이 처리하므로 제외
    onError: (e, q) => { if (q.meta?.error === false || (e instanceof ApiError && e.status === 401)) return; toast.error(`조회 실패: ${msg(e)}`); },
  }),
});
